import React from 'react';
const imageBonuses = [{
  src: 'https://cdn.magicpatterns.com/uploads/mGF7RAJF9c6FBXuDtMws24/Copia_de_Celebrate_Shopify_-_Square_(15).png',
  alt: 'Bono 1: 900 Etiquetas Escolares'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6ZYvAUREGVhEWZJebMjrJP/Copia_de_Celebrate_Shopify_-_Square_(13).png',
  alt: 'Bono 2: 240 Libritos para Colorear'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aefvHmwBSTdgcCLuC6NPzz/Copia_de_Celebrate_Shopify_-_Square_(14).png',
  alt: 'Bono 3: +250 Invitaciones Digitales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qiKH6xiScs9stvisd6ZqWu/Copia_de_Celebrate_Shopify_-_Square_(7).png',
  alt: 'Bono 4: 12 Estilos de Flores de Papel'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sApyvU6AXGQ955MYMi5uEF/Copia_de_Celebrate_Shopify_-_Square_(16).png',
  alt: 'Bono 5: 130 Plantillas de Cajas'
}];
const imageBonuses2 = [{
  src: 'https://cdn.magicpatterns.com/uploads/ihSvL1cNCXzqL68uDxaFQs/Copia_de_Celebrate_Shopify_-_Square_(8).png',
  alt: 'Bono 6: 5 Pizarras de Cumpleaños'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1oeEZ5FgvBES97fgAyhioS/Copia_de_Celebrate_Shopify_-_Square_(9).png',
  alt: 'Bono 7: 1,200 Cake Toppers'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aRGQ6Si5cs1ymERzDc6cJg/Copia_de_Celebrate_Shopify_-_Square_(11).png',
  alt: 'Bono 8: +1,000 Diseños para Sublimación'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4LZjLYFyuUVNqFusfBqSSr/Copia_de_Celebrate_Shopify_-_Square_(10).png',
  alt: 'Bono 9: Calendario de Organización de Fiesta'
}];
export function BonusSection() {
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-light-pink" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <h2 className="text-4xl md:text-6xl font-bold text-magenta mb-6 drop-shadow-sm" data-id="element-17">
            🎁 PERO ESO NO ES TODO…
          </h2>
          <p className="text-xl md:text-2xl font-bold text-teal-600 bg-white inline-block px-8 py-4 rounded-full shadow-sm border-2 border-teal-100" data-id="element-18">
            Hoy, al adquirir el Kit Fiesta Mágica, también recibes estos{' '}
            <span className="text-magenta" data-id="element-19">10 BONOS EXCLUSIVOS</span> — sin
            costo adicional:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-20">
          {/* Image-based bonus cards */}
          {imageBonuses.map((bonus, index) => <div key={`img-${index}`} className="rounded-2xl overflow-hidden shadow-sm border-2 border-pink-100 relative group hover:border-pink-300 hover:shadow-md transition-all duration-300" data-id="element-21">
              <div className="absolute top-0 right-0 bg-teal-400 text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-22">
                BONO {index + 1}
              </div>
              <img src={bonus.src} alt={bonus.alt} className="w-full h-full object-cover aspect-square" data-id="element-23" />
            </div>)}

          {/* Image-based bonus cards 6-9 */}
          {imageBonuses2.map((bonus, index) => <div key={`img2-${index}`} className="rounded-2xl overflow-hidden shadow-sm border-2 border-pink-100 relative group hover:border-pink-300 hover:shadow-md transition-all duration-300" data-id="element-24">
              <div className="absolute top-0 right-0 bg-teal-400 text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-25">
                BONO {index + 6}
              </div>
              <img src={bonus.src} alt={bonus.alt} className="w-full h-full object-cover aspect-square" data-id="element-26" />
            </div>)}
        </div>

        {/* Special Highlight for Bonus 10 */}
        <div className="bg-gradient-to-r from-pink-400 to-orange-400 rounded-3xl p-1 shadow-xl transform hover:scale-[1.02] transition-transform" data-id="element-27">
          <div className="bg-white rounded-[22px] p-8 md:p-10 relative overflow-hidden" data-id="element-28">
            <div className="absolute top-0 right-0 bg-magenta text-white text-sm md:text-base font-bold px-6 py-2 rounded-bl-2xl shadow-md" data-id="element-29">
              BONO ESTRELLA 🌟
            </div>
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-30">
              <div className="text-7xl md:text-8xl drop-shadow-lg" data-id="element-31">🚀</div>
              <div data-id="element-32">
                <h3 className="text-2xl md:text-3xl font-bold text-pink-500 mb-3 font-baloo" data-id="element-33">
                  Bono 10: Guía Para Emprender con Fiestas
                </h3>
                <p className="text-lg text-gray-700 font-medium mb-4" data-id="element-34">
                  Cómo montar tu negocio de decoración desde cero.
                </p>
                <div className="bg-orange-50 p-4 rounded-xl border border-orange-200" data-id="element-35">
                  <p className="text-orange-800 font-medium text-sm md:text-base" data-id="element-36">
                    💡{' '}
                    <strong className="font-bold" data-id="element-37">
                      El Bono 10 es especial:
                    </strong>{' '}
                    aprende a convertir este kit en una fuente de ingresos real.
                    Miles de emprendedoras ya venden decoración de fiestas desde
                    casa. Tú también puedes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}